<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div mat-dialog-content fxFlex>
        <div [innerHTML]="message | safeHTML"></div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-raised-button color="primary" (click)="OKHandler()">{{oktext}}</button>
    </div>
</div>
